<template>
  <v-fade-transition>
    <v-icon v-if="synchronizing" v-show="showSynchronizing" v-text="icon" color="primary" />
    <v-icon v-else v-show="showSynchronize" v-text="icon" color="white" />
  </v-fade-transition>
</template>

<script>
  import { mapState } from 'vuex'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    data: () => ({
      showSynchronizing: undefined,
      showSynchronize: undefined,
      animation: undefined,
    }),

    computed: {
      ...mapState('sync', [
        'synchronizing',
        'shouldSynchronize',
      ]),
      icon () {
        return this.shouldSynchronize ? this.icons.syncAlert : this.icons.sync
      },
    },

    created () {
      this.init()
    },

    watch: {
      synchronizing () {
        this.init()
      },
    },

    methods: {
      hideAll () {
        if (this.animation) {
          clearInterval(this.animation)
          this.animation = null
        }
        this.showSynchronizing = false
        this.showSynchronize = false
      },
      show (callback) {
        setTimeout(callback(), 300)
      },
      init () {
        this.hideAll()
        if (this.synchronizing) {
          this.show(() => this.animation = setInterval(() => this.showSynchronizing = ! this.showSynchronizing, 250))
        } else {
          this.show(() => this.showSynchronize = true)
        }
      },
    },
  }
</script>
